import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { OthersAction } from "../../store/actions";

import Loader from "../loader";
import { Images } from "../../config";

import "./styles.css";

const DefaultFileUpload = ({
  id,
  type,
  value,
  icon = Images.DefaultUpload,
  disabled = false,
  ...props
}) => {
  const dispatch = useDispatch();
  const fileSelect = useRef();

  const { isUploadLoading } = useSelector((state) => state.others);

  const handleFileUpload = (file) => {
    const data = new FormData();

    if (type === "image") {
      data.append("image", file);
      dispatch(
        OthersAction.uploadImage(data, (res) => {
          const fileLink = res.data;
          props?.onChange(fileLink);

          if (fileSelect.current) {
            fileSelect.current.value = "";
          }
        })
      );
    } else {
      data.append("file", file);
      dispatch(
        OthersAction.uploadFile(data, (res) => {
          const fileLink = res.data;
          props?.onChange(fileLink);

          if (fileSelect.current) {
            fileSelect.current.value = "";
          }
        })
      );
    }
  };

  return (
    <div
      onClick={() => {
        fileSelect.current.click();
      }}
      className="default-file-input"
    >
      <input
        style={{ display: "none" }}
        type="file"
        name="image"
        id={`getFile-${id}`}
        ref={fileSelect}
        onChange={(event) => {
          handleFileUpload(event.target.files[0]);
        }}
        disabled={(disabled || isUploadLoading) ?? false}
        accept={
          type === "image"
            ? ".jpg, .jpeg, .png"
            : ".pdf, .csv, .xlsx, .doc, .docx"
        }
      />
      <div
        className={`${
          value ? "opacity-[100%]" : "opacity-[50%]"
        } text-[0.875em]`}
      >
        {value ? "File uploaded" : "Select a file"}
      </div>
      <div>
        {isUploadLoading ? (
          <Loader.Circular size={22} />
        ) : (
          <img src={icon} className="h-[1.125em] pr-2" />
        )}
      </div>
    </div>
  );
};

export default DefaultFileUpload;
